"use client";
import React, { useEffect, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { fetchAppUsage } from "../../../../api/api";

const NewAdmissions = ({ user_id }) => {

  const [Chart, setChart] = useState(null);
  const [range, setRange] = useState("daily");
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [apps, setApps] = useState([]);

  // Load ApexCharts dynamically
  useEffect(() => {
    import("react-apexcharts").then(mod => setChart(() => mod.default));
  }, []);

  // Fetch app usage data
  useEffect(() => {

    const loadApps = async () => {
      try {
        const data = await fetchAppUsage(user_id, range);
        console.log("Chart API:", data);

        const total = data.reduce(
          (sum, d) => sum + (Number(d.total_duration_seconds) || 0),
          0
        );

        let newSeries = data.map(d => {
          const value = Number(d.total_duration_seconds) || 0;
          return total > 0 ? Number(((value / total) * 100).toFixed(2)) : 0;
        });

        let newLabels = data.map(d => d.app_name);

        // If no data or all percentages are 0, provide a fallback so chart renders
        if (newSeries.length === 0) {
          newSeries = [1];
          newLabels = ["No Data"];
        }

        setSeries(newSeries);
        setLabels(newLabels);
        setApps(data);

      } catch (err) {
        console.error("Failed to load apps", err);

        // fallback in case of fetch failure
        setSeries([1]);
        setLabels(["No Data"]);
        setApps([]);
      }
    };

    if (user_id) {
      loadApps();
    }

  }, [user_id, range]);

  const options = {
    labels: labels,
    colors: ["#37D80A", "#FF4023", "#605DFF", "#AD63F6", "#90C7FF"],
    stroke: {
      width: 1,
      show: true,
      colors: ["#ffffff"],
      lineCap: "round",
    },
    legend: {
      show: false
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "80%"
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    tooltip: {
      enabled: true
    }
  };

  return (
    <Card className="rounded-3 bg-white border-0 mb-4">
      <div className="custom-padding-30">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center pb-4">
          <h3 className="mb-0">Used Apps & Websites Percentage</h3>

          <Dropdown>
            <Dropdown.Toggle variant="light" size="sm">
              {range === "daily" && "Today"}
              {range === "weekly" && "Last 7 Days"}
              {range === "monthly" && "Last Month"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setRange("daily")}>Today</Dropdown.Item>
              <Dropdown.Item onClick={() => setRange("weekly")}>Last 7 Days</Dropdown.Item>
              <Dropdown.Item onClick={() => setRange("monthly")}>Last Month</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Chart */}
        <div className="t-chart">
          {Chart && (
            <Chart
              options={{ ...options, labels }}
              series={series}
              type="donut"
              height={250}
            />
          )}
        </div>

        {/* Optional "No Data" message */}
        {apps.length === 0 && <p className="text-center mt-3">No app usage data for this period</p>}

        {/* Legend */}
        {/* {apps.length > 0 && (
          <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">
            {apps.map((app, index) => (
              <div key={index} className="d-flex align-items-center">
                <span
                  className="d-inline-block rounded-circle"
                  style={{
                    width: "11px",
                    height: "11px",
                    backgroundColor: options.colors[index % options.colors.length]
                  }}
                ></span>
                <span className="ms-2">
                  {app.app_name}: <span className="fw-semibold">{app.percent}%</span>
                </span>
              </div>
            ))}
          </div>
        )} */}

      </div>
    </Card>
  );
};

export default NewAdmissions;